import { darken, rgba } from 'polished';
import pallette from './pallette';

type LayoutTheme = {
    colors: {
        cookieConsent: {
            text: string;
            background: string;
            border: string;
        };
        footer: {
            text: string;
            background: string;
            border: string;
        };
        scrollArea: {
            scrollbar: string;
            hover: { scrollbar: string };
        };
        table: {
            border: string;
            header: { text: string; background: string };
            body: { text: string; background: string; stripedRow: string };
            footer: { text: string; background: string };
        };
        labelDivider: {
            border: string;
            badge: { text: string; background: string; border: string };
        };
    };
};

const { transparent, white, black, lightBlue, darkBlue, teal } = pallette;

const layout: LayoutTheme = {
    colors: {
        cookieConsent: {
            text: white,
            background: darken(0.09, darkBlue),
            border: darken(0.09, darkBlue),
        },
        footer: {
            text: white,
            background: darkBlue,
            border: lightBlue,
        },
        scrollArea: {
            scrollbar: rgba(teal, 0.3),
            hover: {
                scrollbar: teal,
            },
        },
        table: {
            border: darkBlue,
            header: {
                text: teal,
                background: darkBlue,
            },
            body: {
                text: white,
                background: transparent,
                stripedRow: rgba(black, 0.09),
            },
            footer: {
                text: teal,
                background: darkBlue,
            },
        },
        labelDivider: {
            border: darkBlue,
            badge: {
                text: darkBlue,
                background: teal,
                border: teal,
            },
        },
    },
};

export default layout;
